import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Lightbulb, CheckCircle } from './Icons';
export function RevelationSection() {
  return <section className="py-10 md:py-20 px-4 bg-navy text-white relative overflow-hidden" data-id="element-138">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-139">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-sage blur-[100px]" data-id="element-140"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-terracotta blur-[100px]" data-id="element-141"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 md:mb-12" data-id="element-143">
          <div className="inline-flex items-center justify-center p-4 bg-white/10 rounded-full mb-6 backdrop-blur-sm" data-id="element-144">
            <Lightbulb className="w-10 h-10 text-amber" data-id="element-145" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 text-cream" data-id="element-146">
            Descubrí que el problema no es la tecnología...
          </h2>
          <p className="text-2xl md:text-3xl font-serif text-amber-light italic mb-12" data-id="element-147">
            ...sino el umbral de dopamina.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white text-warm-dark rounded-2xl md:rounded-3xl p-5 md:p-12 shadow-2xl" data-id="element-148">
          <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-149">
            <div className="w-24 h-24 bg-sage-light rounded-full flex items-center justify-center flex-shrink-0" data-id="element-150">
              <Brain className="w-12 h-12 text-sage" data-id="element-151" />
            </div>
            <div data-id="element-152">
              <h3 className="text-2xl md:text-3xl font-bold text-navy mb-3" data-id="element-153">
                He creado el Método{' '}
                <span className="text-terracotta" data-id="element-154">Infancia Analógica</span>
              </h3>
              <p className="text-lg text-warm-medium" data-id="element-155">
                Un sistema de 30 días diseñado para "re-setear" la atención de
                tu hijo mediante micro-estímulos de baja fidelidad.
              </p>
            </div>
          </div>

          <div className="bg-cream-dark p-6 rounded-2xl border border-cream" data-id="element-156">
            <div className="flex items-start gap-4" data-id="element-157">
              <CheckCircle className="w-8 h-8 text-sage flex-shrink-0 mt-1" data-id="element-158" />
              <p className="text-xl text-navy font-medium leading-relaxed" data-id="element-159">
                No vamos a prohibir el internet; vamos a hacer que{' '}
                <strong className="bg-amber-light px-2 py-1 rounded text-navy" data-id="element-160">
                  el mundo real sea mucho más interesante
                </strong>{' '}
                que un video de 15 segundos.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}